import React from "react";
import { LayoutGrid } from "lucide-react";
import { LAYOUTS, COLOR_THEMES, getAccentHex } from "@/components/resume-builder/templates/templateConfig";

/** Layout + color picker — shared between the Advanced (all-in-one) editor's
 * sidebar panel and Step 1 ("Basics") of the Guided Wizard. */
export default function TemplateColorPicker({ draft, setDraft, onBrowseAll }) {
  return (
    <div className="glass-panel rounded-2xl p-4" data-testid="resume-template-color-picker">
      <div className="flex items-center justify-between mb-2">
        <p className="text-xs font-semibold text-slate-300">Layout <span className="text-slate-500 font-normal">({LAYOUTS.length} layouts × {COLOR_THEMES.length} colors = {LAYOUTS.length * COLOR_THEMES.length} looks)</span></p>
        <button onClick={onBrowseAll} data-testid="resume-browse-templates-button" className="flex items-center gap-1 text-[11px] font-semibold text-indigo-300 hover:text-indigo-200">
          <LayoutGrid className="w-3 h-3" /> Browse All Templates
        </button>
      </div>
      <div className="flex flex-wrap gap-2" data-testid="resume-template-selector">
        {LAYOUTS.map((t) => (
          <button
            key={t.id} onClick={() => setDraft({ ...draft, template: t.id })} data-testid={`resume-template-${t.id}`}
            className={`flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-full border transition-colors ${
              draft.template === t.id ? "text-white" : "text-slate-400 border-transparent hover:text-white"
            }`}
            style={draft.template === t.id ? { backgroundColor: `${getAccentHex(draft.template_color)}33`, borderColor: `${getAccentHex(draft.template_color)}80` } : {}}
          >
            {t.label}
            {t.atsFriendly && <span className="text-[9px] font-bold uppercase bg-emerald-400/15 text-emerald-300 px-1.5 py-0.5 rounded-full ml-0.5">ATS</span>}
          </button>
        ))}
      </div>
      <p className="text-xs font-semibold text-slate-300 mb-2 mt-4">Color</p>
      <div className="flex flex-wrap gap-2" data-testid="resume-color-selector">
        {COLOR_THEMES.map((c) => (
          <button
            key={c.id} onClick={() => setDraft({ ...draft, template_color: c.id })} data-testid={`resume-color-${c.id}`}
            title={c.label}
            className={`w-7 h-7 rounded-full transition-transform ${draft.template_color === c.id ? "ring-2 ring-white scale-110" : "hover:scale-105"}`}
            style={{ backgroundColor: c.hex }}
          />
        ))}
      </div>
    </div>
  );
}
